import React from 'react';
import classes from './Button.module.css'

import buttonImg from '../../../assets/images/question.svg';

const Button = (props) => {
    const style = {
        backgroundImage:`url(${buttonImg})`
    }
    return ( 
    <div className={classes.Button} onClick={props.click} style={style}></div> );
}
 
export default Button;